import {
  EmailCertifiedConfig,
  EmailConfig,
  NodeConfig,
  SMSCertifiedConfig,
  SMSConfig,
} from '@modules/campaigns/Domain/Interfaces/INodeConfig';

export function hascopyIds(
  config: NodeConfig,
): config is
  | SMSConfig
  | SMSCertifiedConfig
  | EmailConfig
  | EmailCertifiedConfig {
  return 'copyIds' in config;
}
